import React, { useState, useEffect } from "react";
import { Doughnut } from "react-chartjs-2";
import { useUserContext } from "../../context/UserContext";
import api from "../../Axios/api";

const DoughnutChart = () => {
  const { store } = useUserContext();
  const token = store.data.token;
  const [databaseUsage, setDataBaseUsage] = useState();
  const [totalSpace, setTotalSpace] = useState();
  const [occupiedSpace, setOccupiedSpace] = useState();
  // const [spaceInt, setSpaceInt] = useState([680, 578000]);
  useEffect(() => {
    api
      .get("/superAdmin/system/analytics", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log(res.data.data);
        // console.log(res.data.data.storgae.totalSpace);
        setDataBaseUsage(res.data.data.storage);
        setOccupiedSpace(parseInt(res.data.data.storage.occupiedSpace));
        setTotalSpace(parseInt(res.data.data.storage.totalSpace) * 1024);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  }, [token]);

  const data = {
    labels: ["Used", "Unused"],
    datasets: [
      {
        label: "DataBase Usage",
        data: [occupiedSpace, totalSpace],
        backgroundColor: ["#19B500", "#2196f3"],
        borderColor: ["grey", "grey"],
        borderWidth: 1,
      },
    ],
  };

  return <Doughnut data={data} />;
};

export default DoughnutChart;
